export * from "./returnStatus";

export enum ApiRoutesReturns {
  AllReturns = "admin/orders/returns-all",
  ReturnDetails = "admin/orders/return-details",
  ApproveReturn = "admin/orders/approve-return",
  RejectReturn = "admin/orders/cancel-return"
}
